import { Component, OnDestroy, OnInit } from '@angular/core';
import { CompanyFacade } from '@ridango/components';
import { AccessType, AuthService, Company, PowerUser } from '@ridango/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: './account-company-users-list-page.component.html'
})
export class AccountCompanyUsersListPageComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject<void>();

    selectedCompany$ = this.companyFacade.selectedCompany$;
    powerUsers$ = this.companyFacade.powerUsers$;
    AccessType = AccessType;

    companyId: number;
    showDeleteConfirmation = false;
    userIdToDelete: number;

    constructor(
        private companyFacade: CompanyFacade,
        private authService: AuthService
    ) {}

    ngOnInit() {
        this.companyId = this.authService.getLoggedInUserCompanyId();

        if (this.companyId) {
            this.companyFacade.fetchPowerUsers(this.companyId);
        }
        this.selectedCompany$.pipe(takeUntil(this.componentDestroyed$)).subscribe((c: Company) => {
            if (c?.id) {
                this.companyFacade.fetchPowerUsers(c.id);
            }
        });
    }

    ngOnDestroy(): void {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    askToDelete(user: PowerUser) {
        this.showDeleteConfirmation = true;
        this.userIdToDelete = user.id;
    }

    confirmDelete() {
        this.showDeleteConfirmation = false;
        this.companyFacade.deletePowerUser(this.companyId, this.userIdToDelete);
    }

    cancelDelete() {
        this.showDeleteConfirmation = false;
    }
}
